import { ApplicantDetailsStepView } from "./applicant-details-step-view";
import { useApplicantDetailsStep } from "./use-applicant-details-step";

export default function ApplicantDetailsStep() {
  const logic = useApplicantDetailsStep();

  return <ApplicantDetailsStepView {...logic} />;
}
